import React, { FC } from 'react'
import { useTheme } from 'react-jss'

import {
  ColorDot,
  getCurrencySymbol,
  OptionExtraRow,
  Row,
  Text
} from '../../../components'
import { LightTheme } from '../../../theme'

import { useStyle } from './details-block-option.styles'
import { DetailsBlockOptionProps } from './details-block-option.types'

export const DetailsBlockOption: FC<DetailsBlockOptionProps> = ({
  className = '',
  color,
  label,
  labelTx,
  text,
  tx,
  extraPrice,
  extraDays,
  isOptionSection,
  currency
}) => {
  const theme = useTheme<LightTheme>()
  const classes = useStyle()
  const currencySymbol = getCurrencySymbol(currency)

  return (
    <Row fullWidth justifyContent="flex-start" className={className}>
      <ColorDot
        className={classes.dot}
        color={theme.colors.yellow}
        preset="mini"
      />
      {color && (
        <ColorDot
          className={classes.color}
          color={color}
          preset="productColor"
        />
      )}
      {label && (
        <Text
          color="inactive"
          className={classes.text}
          text={label}
          tx={labelTx}
        />
      )}
      <Text className={classes.text} text={text} tx={tx} />
      {isOptionSection && (
        <OptionExtraRow
          className={classes.extraRow}
          extraPrice={extraPrice}
          extraDays={extraDays}
          currencySymbol={currencySymbol}
        />
      )}
    </Row>
  )
}
